import { countLogs, countThreats, getAllImports, clearAll, countEmailLogs } from '../services/storage.js';
import { ConfirmDialog } from './confirm-dialog.js';
import './toast-container.js';

const template = document.createElement('template');
template.innerHTML = `
  <div class="app-shell-inner">
    <header class="app-header" style="position:relative">
      <div class="logo">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          <path d="M9 12l2 2 4-4"/>
        </svg>
        ThreatScope
      </div>
      <div class="header-actions">
        <button class="btn btn-sm btn-secondary" data-action="settings" title="Settings">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="3"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
          </svg>
        </button>
        <button class="btn btn-sm btn-secondary" data-action="clear-all" title="Clear All Data">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/>
          </svg>
        </button>
      </div>
    </header>
    <div class="app-body">
      <nav class="app-sidebar">
        <div class="nav-item active" data-pane="dashboard" title="Dashboard (⌘1)">
          <span class="nav-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
            </svg>
          </span>
        </div>
        <div class="nav-item" data-pane="imports" title="Import Logs (⌘2)">
          <span class="nav-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
          </span>
          <span class="nav-badge" id="badge-imports" style="display:none">0</span>
        </div>
        <div class="nav-item" data-pane="logs" title="Review Logs (⌘3)">
          <span class="nav-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
            </svg>
          </span>
          <span class="nav-badge" id="badge-logs" style="display:none">0</span>
        </div>
        <div class="nav-item" data-pane="threats" title="Threat Analysis (⌘4)">
          <span class="nav-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </span>
          <span class="nav-badge" id="badge-threats" style="display:none">0</span>
        </div>
        <div class="nav-item" data-pane="map" title="World Map (⌘5)">
          <span class="nav-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
            </svg>
          </span>
        </div>
        <div class="nav-item" data-pane="export" title="Export Reports (⌘6)">
          <span class="nav-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
          </span>
        </div>
        <div class="nav-item" data-pane="email-headers" title="Email Headers (⌘7)">
          <span class="nav-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
          </span>
        </div>
        <div class="nav-item" data-pane="email-logs" title="Email Logs (⌘8)">
          <span class="nav-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
              <line x1="12" y1="8" x2="12" y2="14"/>
              <line x1="9" y1="11" x2="15" y2="11"/>
            </svg>
          </span>
          <span class="nav-badge" id="badge-email-logs" style="display:none">0</span>
        </div>
      </nav>
      <main class="app-content">
        <div class="app-pane active" data-pane="dashboard">
          <dashboard-pane></dashboard-pane>
        </div>
        <div class="app-pane" data-pane="imports">
          <import-pane></import-pane>
        </div>
        <div class="app-pane" data-pane="logs">
          <log-table></log-table>
        </div>
        <div class="app-pane" data-pane="threats">
          <threat-pane></threat-pane>
        </div>
        <div class="app-pane" data-pane="map">
          <world-map></world-map>
        </div>
        <div class="app-pane" data-pane="export">
          <export-panel></export-panel>
        </div>
        <div class="app-pane" data-pane="email-headers">
          <email-header-pane></email-header-pane>
        </div>
        <div class="app-pane" data-pane="email-logs">
          <email-log-table></email-log-table>
        </div>
      </main>
    </div>
    <footer class="app-status-bar">
      <span class="status-item">
        <span class="status-dot"></span>
        <span id="status-ready">Ready</span>
      </span>
      <span class="status-item" id="status-logs">
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
        0 logs
      </span>
      <span class="status-item" id="status-threats">
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/></svg>
        0 threats
      </span>
      <span class="status-item" id="status-imports">
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
        0 imports
      </span>
      <span class="status-item" id="status-email-logs">
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
        0 email logs
      </span>
      <span class="status-item" style="margin-left: auto" id="status-info"></span>
    </footer>
  </div>
`;

let instanceCount = 0;

export class AppShell extends HTMLElement {
  constructor() {
    super();
    this._id = instanceCount++;
    this.currentPane = 'dashboard';
    this.innerHTML = template.innerHTML;
  }

  connectedCallback() {
    this.querySelectorAll('.nav-item').forEach(item => {
      item.addEventListener('click', () => this.switchPane(item.dataset.pane));
    });

    this.querySelector('[data-action="settings"]')
      .addEventListener('click', () => this.openSettings());

    this.querySelector('[data-action="clear-all"]')
      .addEventListener('click', () => this.confirmClearAll());

    this.refreshStats();

    document.addEventListener('threatscope:stats-update', () => this.refreshStats());
    document.addEventListener('threatscope:show-detail', (e) => this.showDetail(e.detail));
    document.addEventListener('threatscope:close-detail', () => this.closeDetail());
    document.addEventListener('threatscope:switch-pane', (e) => {
      if (e.detail && e.detail.pane) this.switchPane(e.detail.pane);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeDetail();

      if (!e.metaKey && !e.ctrlKey && !e.altKey) {
        const paneKeys = { '1': 'dashboard', '2': 'imports', '3': 'logs', '4': 'threats', '5': 'map', '6': 'export', '7': 'email-headers', '8': 'email-logs' };
        if (e.key in paneKeys && !e.target.closest('input, select, textarea')) {
          this.switchPane(paneKeys[e.key]);
        }
        if (e.key === '/' && !e.target.closest('input, select, textarea')) {
          e.preventDefault();
          const searchInput = this.querySelector('.app-pane.active input[type="text"]');
          if (searchInput) searchInput.focus();
        }
      }
    });
  }

  async refreshStats() {
    const logCount = await countLogs();
    const threatCount = await countThreats();
    const imports = await getAllImports();

    const emailLogCount = await countEmailLogs();

    const badges = {
      logs: this.querySelector('#badge-logs'),
      threats: this.querySelector('#badge-threats'),
      imports: this.querySelector('#badge-imports'),
      emailLogs: this.querySelector('#badge-email-logs'),
    };

    badges.logs.textContent = logCount;
    badges.logs.style.display = logCount > 0 ? '' : 'none';
    badges.threats.textContent = threatCount;
    badges.threats.style.display = threatCount > 0 ? '' : 'none';
    badges.imports.textContent = imports.length;
    badges.imports.style.display = imports.length > 0 ? '' : 'none';
    badges.emailLogs.textContent = emailLogCount;
    badges.emailLogs.style.display = emailLogCount > 0 ? '' : 'none';

    this.querySelector('#status-logs').innerHTML = `
      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
      ${logCount} logs
    `;
    this.querySelector('#status-threats').innerHTML = `
      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/></svg>
      ${threatCount} threats
    `;
    this.querySelector('#status-imports').innerHTML = `
      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
      ${imports.length} imports
    `;
    this.querySelector('#status-email-logs').innerHTML = `
      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
      ${emailLogCount} email logs
    `;
  }

  setStatus(text) {
    this.querySelector('#status-info').textContent = text;
  }

  switchPane(paneName) {
    this.currentPane = paneName;

    this.querySelectorAll('.nav-item').forEach(item => {
      item.classList.toggle('active', item.dataset.pane === paneName);
    });

    const panes = this.querySelector('.app-content').querySelectorAll('.app-pane');
    panes.forEach(p => p.classList.toggle('active', p.dataset.pane === paneName));

    const paneEl = this.querySelector(`.app-pane[data-pane="${paneName}"]`);
    if (paneEl) paneEl.scrollTop = 0;

    if (paneName === 'map') {
      const mapEl = this.querySelector('.app-pane[data-pane="map"] world-map');
      if (mapEl) mapEl.invalidateSize();
    }
    if (paneName === 'logs') {
      const logEl = this.querySelector('.app-pane[data-pane="logs"] log-table');
      if (logEl) logEl.refresh();
    }
    if (paneName === 'threats') {
      const threatEl = this.querySelector('.app-pane[data-pane="threats"] threat-pane');
      if (threatEl) threatEl.refresh();
    }
    if (paneName === 'imports') {
      const importEl = this.querySelector('.app-pane[data-pane="imports"] import-pane');
      if (importEl) importEl.refresh();
    }
    if (paneName === 'dashboard') {
      const dashEl = this.querySelector('.app-pane[data-pane="dashboard"] dashboard-pane');
      if (dashEl) dashEl.refresh();
    }
    if (paneName === 'email-headers') {
      const headerEl = this.querySelector('.app-pane[data-pane="email-headers"] email-header-pane');
      if (headerEl && headerEl.refresh) headerEl.refresh();
    }
    if (paneName === 'email-logs') {
      const logEl = this.querySelector('.app-pane[data-pane="email-logs"] email-log-table');
      if (logEl) logEl.refresh();
    }
  }

  showDetail(data) {
    let panel = this.querySelector('.detail-overlay');
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'detail-overlay';
      panel.innerHTML = '<detail-panel></detail-panel>';
      panel.addEventListener('click', (e) => {
        if (e.target === panel) this.closeDetail();
      });
      this.querySelector('.app-shell-inner').appendChild(panel);
    }
    const detailEl = panel.querySelector('detail-panel');
    detailEl.data = data;
  }

  closeDetail() {
    const overlay = this.querySelector('.detail-overlay');
    if (overlay) overlay.remove();
  }

  openSettings() {
    let panel = this.querySelector('.detail-overlay');
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'detail-overlay';
      panel.addEventListener('click', (e) => {
        if (e.target === panel) this.closeDetail();
      });
      this.querySelector('.app-shell-inner').appendChild(panel);
    }
    panel.innerHTML = '<settings-panel></settings-panel>';
  }

  async confirmClearAll() {
    const confirmed = await ConfirmDialog.show({
      title: 'Clear All Data',
      message: 'This will permanently delete all logs, threats, enrichments, and import history. This action cannot be undone.',
      confirmText: 'Delete Everything',
      cancelText: 'Cancel',
      variant: 'danger',
    });
    if (!confirmed) return;

    await clearAll();
    this.refreshStats();
    document.dispatchEvent(new CustomEvent('threatscope:data-cleared'));
    window.showToast('All data cleared', 'success');
  }
}

customElements.define('app-shell', AppShell);
